// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * TwentyTwentysix Login — matches homepage/collective palette and container.
 * Uses tokens.css (loaded by layout) + Mamahood-style variables for consistency.
 */
.twentytwentysix-login {
  --al-cream: #efe4d3;
  --al-light: #f5f3f1;
  --al-teal: #6f9f9a;
  --al-coral: #df775f;
  --al-gold: #d8b04e;
  --al-text: #433d43;
  --al-muted: #6b666b;
  --al-white: #ffffff;
  --al-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  --al-radius: 20px;
  --al-font-display: "fabulosa", sans-serif;

  min-height: 60vh;
  background: var(--al-light);
  color: var(--al-text);
  font-family: Arial, Helvetica, sans-serif;
  padding: var(--twentytwentysix-spacing-section, 56px) 0;
}

.twentytwentysix-login__container {
  width: min(var(--twentytwentysix-container-max, 1280px), calc(100% - 48px));
  margin: 0 auto;
  max-width: 520px;
}

.twentytwentysix-login__card {
  background: var(--al-white);
  border-radius: var(--al-radius);
  box-shadow: var(--al-shadow);
  padding: 32px 36px 40px;
}

.twentytwentysix-login__title {
  font-family: var(--al-font-display);
  font-weight: 400;
  font-size: clamp(1.75rem, 3vw, 2.25rem);
  color: var(--al-teal);
  margin: 0 0 8px;
  text-align: center;
}

.twentytwentysix-login__subtitle {
  text-align: center;
  font-size: 1rem;
  color: var(--al-muted);
  margin: 0 0 24px;
}

.twentytwentysix-login__divider {
  height: 1px;
  background: #e0e0e0;
  margin: 24px 0;
}

.twentytwentysix-login__section-title {
  font-size: 0.9rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--al-text);
  margin: 0 0 16px;
}

.twentytwentysix-login__social-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.twentytwentysix-login__social-btn {
  display: block;
  width: 100%;
  padding: 12px 20px;
  border: none;
  border-radius: 999px;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.twentytwentysix-login__social-btn:hover {
  transform: translateY(-2px);
  box-shadow: var(--al-shadow);
}
.twentytwentysix-login__social-btn--google {
  background: #fff;
  color: #333;
  border: 1px solid #ddd;
}
.twentytwentysix-login__social-btn--facebook {
  background: #1877f2;
  color: var(--al-white);
}

.twentytwentysix-login__form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.twentytwentysix-login__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.twentytwentysix-login__label {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--al-text);
}

.twentytwentysix-login__input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #cfc6bf;
  border-radius: 10px;
  font-size: 1rem;
  font-family: inherit;
  background: var(--al-white);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.twentytwentysix-login__input:focus {
  outline: none;
  border-color: var(--al-teal);
  box-shadow: 0 0 0 2px rgba(111, 159, 154, 0.25);
}

.twentytwentysix-login__error {
  background: #fde8e8;
  color: #c00;
  padding: 12px 16px;
  border-radius: 10px;
  font-size: 0.9rem;
}

.twentytwentysix-login__submit {
  width: 100%;
  padding: 14px 24px;
  border: none;
  border-radius: 999px;
  background: var(--al-gold);
  color: var(--al-white);
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  box-shadow: var(--al-shadow);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.twentytwentysix-login__submit:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 14px 40px rgba(0, 0, 0, 0.12);
}
.twentytwentysix-login__submit:active:not(:disabled) {
  transform: translateY(0);
}
.twentytwentysix-login__submit:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
.twentytwentysix-login__submit:focus-visible {
  outline: 2px solid var(--al-teal);
  outline-offset: 2px;
}

.twentytwentysix-login__links {
  text-align: center;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.twentytwentysix-login__link {
  color: var(--al-teal);
  font-weight: 600;
  text-decoration: none;
  font-size: 0.95rem;
  transition: color 0.2s ease;
}
.twentytwentysix-login__link:hover {
  color: var(--al-coral);
}
.twentytwentysix-login__link:focus-visible {
  outline: 2px solid var(--al-teal);
  outline-offset: 2px;
  border-radius: 2px;
}

.twentytwentysix-login__hint {
  font-size: 0.9rem;
  color: var(--al-muted);
  margin: 0;
}
.twentytwentysix-login__hint a {
  color: var(--al-teal);
  font-weight: 600;
  text-decoration: none;
}
.twentytwentysix-login__hint a:hover {
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/components/twentytwentysix/styles/TwentyTwentysixLogin.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,4CAA4C;EAC5C,iBAAiB;EACjB,yCAAyC;;EAEzC,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;EACrB,yCAAyC;EACzC,uDAAuD;AACzD;;AAEA;EACE,2EAA2E;EAC3E,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,uCAAuC;EACvC,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,2BAA2B;EAC3B,wDAAwD;AAC1D;AACA;EACE,aAAa;EACb,4BAA4B;EAC5B,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,0BAA0B;EAC1B,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,qDAAqD;AACvD;AACA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B","sourcesContent":["/**\n * TwentyTwentysix Login — matches homepage/collective palette and container.\n * Uses tokens.css (loaded by layout) + Mamahood-style variables for consistency.\n */\n.twentytwentysix-login {\n  --al-cream: #efe4d3;\n  --al-light: #f5f3f1;\n  --al-teal: #6f9f9a;\n  --al-coral: #df775f;\n  --al-gold: #d8b04e;\n  --al-text: #433d43;\n  --al-muted: #6b666b;\n  --al-white: #ffffff;\n  --al-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);\n  --al-radius: 20px;\n  --al-font-display: \"fabulosa\", sans-serif;\n\n  min-height: 60vh;\n  background: var(--al-light);\n  color: var(--al-text);\n  font-family: Arial, Helvetica, sans-serif;\n  padding: var(--twentytwentysix-spacing-section, 56px) 0;\n}\n\n.twentytwentysix-login__container {\n  width: min(var(--twentytwentysix-container-max, 1280px), calc(100% - 48px));\n  margin: 0 auto;\n  max-width: 520px;\n}\n\n.twentytwentysix-login__card {\n  background: var(--al-white);\n  border-radius: var(--al-radius);\n  box-shadow: var(--al-shadow);\n  padding: 32px 36px 40px;\n}\n\n.twentytwentysix-login__title {\n  font-family: var(--al-font-display);\n  font-weight: 400;\n  font-size: clamp(1.75rem, 3vw, 2.25rem);\n  color: var(--al-teal);\n  margin: 0 0 8px;\n  text-align: center;\n}\n\n.twentytwentysix-login__subtitle {\n  text-align: center;\n  font-size: 1rem;\n  color: var(--al-muted);\n  margin: 0 0 24px;\n}\n\n.twentytwentysix-login__divider {\n  height: 1px;\n  background: #e0e0e0;\n  margin: 24px 0;\n}\n\n.twentytwentysix-login__section-title {\n  font-size: 0.9rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: var(--al-text);\n  margin: 0 0 16px;\n}\n\n.twentytwentysix-login__social-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.twentytwentysix-login__social-btn {\n  display: block;\n  width: 100%;\n  padding: 12px 20px;\n  border: none;\n  border-radius: 999px;\n  font-size: 1rem;\n  font-weight: 700;\n  cursor: pointer;\n  text-align: center;\n  text-decoration: none;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n.twentytwentysix-login__social-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--al-shadow);\n}\n.twentytwentysix-login__social-btn--google {\n  background: #fff;\n  color: #333;\n  border: 1px solid #ddd;\n}\n.twentytwentysix-login__social-btn--facebook {\n  background: #1877f2;\n  color: var(--al-white);\n}\n\n.twentytwentysix-login__form {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.twentytwentysix-login__field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.twentytwentysix-login__label {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--al-text);\n}\n\n.twentytwentysix-login__input {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid #cfc6bf;\n  border-radius: 10px;\n  font-size: 1rem;\n  font-family: inherit;\n  background: var(--al-white);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n.twentytwentysix-login__input:focus {\n  outline: none;\n  border-color: var(--al-teal);\n  box-shadow: 0 0 0 2px rgba(111, 159, 154, 0.25);\n}\n\n.twentytwentysix-login__error {\n  background: #fde8e8;\n  color: #c00;\n  padding: 12px 16px;\n  border-radius: 10px;\n  font-size: 0.9rem;\n}\n\n.twentytwentysix-login__submit {\n  width: 100%;\n  padding: 14px 24px;\n  border: none;\n  border-radius: 999px;\n  background: var(--al-gold);\n  color: var(--al-white);\n  font-size: 1rem;\n  font-weight: 700;\n  cursor: pointer;\n  box-shadow: var(--al-shadow);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n.twentytwentysix-login__submit:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 14px 40px rgba(0, 0, 0, 0.12);\n}\n.twentytwentysix-login__submit:active:not(:disabled) {\n  transform: translateY(0);\n}\n.twentytwentysix-login__submit:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n.twentytwentysix-login__submit:focus-visible {\n  outline: 2px solid var(--al-teal);\n  outline-offset: 2px;\n}\n\n.twentytwentysix-login__links {\n  text-align: center;\n  margin-top: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.twentytwentysix-login__link {\n  color: var(--al-teal);\n  font-weight: 600;\n  text-decoration: none;\n  font-size: 0.95rem;\n  transition: color 0.2s ease;\n}\n.twentytwentysix-login__link:hover {\n  color: var(--al-coral);\n}\n.twentytwentysix-login__link:focus-visible {\n  outline: 2px solid var(--al-teal);\n  outline-offset: 2px;\n  border-radius: 2px;\n}\n\n.twentytwentysix-login__hint {\n  font-size: 0.9rem;\n  color: var(--al-muted);\n  margin: 0;\n}\n.twentytwentysix-login__hint a {\n  color: var(--al-teal);\n  font-weight: 600;\n  text-decoration: none;\n}\n.twentytwentysix-login__hint a:hover {\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
